import { ErrorNote } from './ui'

/**
 * Visar varför en lista är tom när orsaken är ett fel och inte brist på data.
 *
 * Utan den här blir ett databasfel till "Inget häfte aktiverat än" – ett
 * påstående som är osant och som skickar någon att leta efter en lapp hen
 * redan använt. Ett tomt tillstånd får bara betyda tomt.
 *
 * Det överlägset vanligaste felet är ett saknat sammansatt index. Firestore
 * lägger med en färdig länk för att skapa det i felmeddelandet, så den plockas
 * fram och görs klickbar för den som är admin, medan förstaraden är skriven
 * så att en köpare också förstår den.
 */
export function QueryError({ error }: { error: Error | null }) {
  if (!error) return null

  const message = error.message ?? ''
  const indexUrl = message.match(/https:\/\/console\.firebase\.google\.com\/\S+/)?.[0]

  return (
    <ErrorNote>
      Informationen kunde inte hämtas just nu. Prova att ladda om sidan – kvarstår det, hör av dig
      till kansliet.
      {indexUrl && (
        <>
          {' '}
          <a
            href={indexUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="font-bold underline underline-offset-2"
          >
            (Admin: databasen saknar ett index – skapa det här)
          </a>
        </>
      )}
    </ErrorNote>
  )
}
